/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intro_Region_Microstates_DescriptionInputs */

const bn_intro_region_microstates_description = /** @type {(inputs: Intro_Region_Microstates_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ক্ষুদ্র লক্ষ্য এবং উচ্চ-নির্ভুল ভূগোল।`)
};

const de_intro_region_microstates_description = /** @type {(inputs: Intro_Region_Microstates_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Winzige Ziele und hochpräzise Geographie.`)
};

const el_intro_region_microstates_description = /** @type {(inputs: Intro_Region_Microstates_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μικροί στόχοι και γεωγραφία υψηλής ακρίβειας.`)
};

const en_intro_region_microstates_description = /** @type {(inputs: Intro_Region_Microstates_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiny targets and high-precision geography.`)
};

const es_intro_region_microstates_description = /** @type {(inputs: Intro_Region_Microstates_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objetivos diminutos y geografía de alta precisión.`)
};

const fr_intro_region_microstates_description = /** @type {(inputs: Intro_Region_Microstates_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Petites cibles et géographie de haute précision.`)
};

const hi_intro_region_microstates_description = /** @type {(inputs: Intro_Region_Microstates_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`छोटे लक्ष्य और उच्च परिशुद्धता भूगोल।`)
};

const hu_intro_region_microstates_description = /** @type {(inputs: Intro_Region_Microstates_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apró célok és nagy pontosságú földrajz.`)
};

const id_intro_region_microstates_description = /** @type {(inputs: Intro_Region_Microstates_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target kecil dan geografi presisi tinggi.`)
};

const it_intro_region_microstates_description = /** @type {(inputs: Intro_Region_Microstates_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obiettivi minuscoli e geografia ad alta precisione.`)
};

const ja_intro_region_microstates_description = /** @type {(inputs: Intro_Region_Microstates_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`小さなターゲットと高精度の地理。`)
};

const ko_intro_region_microstates_description = /** @type {(inputs: Intro_Region_Microstates_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`작은 목표와 고정밀 지리.`)
};

const nl_intro_region_microstates_description = /** @type {(inputs: Intro_Region_Microstates_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kleine doelen en uiterst nauwkeurige geografie.`)
};

const pl_intro_region_microstates_description = /** @type {(inputs: Intro_Region_Microstates_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Małe cele i bardzo precyzyjna geografia.`)
};

const pt_intro_region_microstates_description = /** @type {(inputs: Intro_Region_Microstates_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alvos minúsculos e geografia de alta precisão.`)
};

const ru_intro_region_microstates_description = /** @type {(inputs: Intro_Region_Microstates_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Крошечные цели и высокоточная география.`)
};

const sv_intro_region_microstates_description = /** @type {(inputs: Intro_Region_Microstates_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Små mål och geografi med hög precision.`)
};

const tr_intro_region_microstates_description = /** @type {(inputs: Intro_Region_Microstates_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Küçük hedefler ve yüksek hassasiyetli coğrafya.`)
};

const uk_intro_region_microstates_description = /** @type {(inputs: Intro_Region_Microstates_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Крихітні цілі та високоточна географія.`)
};

const vi_intro_region_microstates_description = /** @type {(inputs: Intro_Region_Microstates_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mục tiêu nhỏ và địa lý có độ chính xác cao.`)
};

const zh_intro_region_microstates_description = /** @type {(inputs: Intro_Region_Microstates_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`微小目标和高精度地理。`)
};

const zh_hant_intro_region_microstates_description = /** @type {(inputs: Intro_Region_Microstates_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`微小目標和高精度地理。`)
};

/**
* | output |
* | --- |
* | "Tiny targets and high-precision geography." |
*
* @param {Intro_Region_Microstates_DescriptionInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const intro_region_microstates_description = /** @type {((inputs?: Intro_Region_Microstates_DescriptionInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intro_Region_Microstates_DescriptionInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_intro_region_microstates_description(inputs)
	if (locale === "de") return de_intro_region_microstates_description(inputs)
	if (locale === "el") return el_intro_region_microstates_description(inputs)
	if (locale === "en") return en_intro_region_microstates_description(inputs)
	if (locale === "es") return es_intro_region_microstates_description(inputs)
	if (locale === "fr") return fr_intro_region_microstates_description(inputs)
	if (locale === "hi") return hi_intro_region_microstates_description(inputs)
	if (locale === "hu") return hu_intro_region_microstates_description(inputs)
	if (locale === "id") return id_intro_region_microstates_description(inputs)
	if (locale === "it") return it_intro_region_microstates_description(inputs)
	if (locale === "ja") return ja_intro_region_microstates_description(inputs)
	if (locale === "ko") return ko_intro_region_microstates_description(inputs)
	if (locale === "nl") return nl_intro_region_microstates_description(inputs)
	if (locale === "pl") return pl_intro_region_microstates_description(inputs)
	if (locale === "pt") return pt_intro_region_microstates_description(inputs)
	if (locale === "ru") return ru_intro_region_microstates_description(inputs)
	if (locale === "sv") return sv_intro_region_microstates_description(inputs)
	if (locale === "tr") return tr_intro_region_microstates_description(inputs)
	if (locale === "uk") return uk_intro_region_microstates_description(inputs)
	if (locale === "vi") return vi_intro_region_microstates_description(inputs)
	if (locale === "zh") return zh_intro_region_microstates_description(inputs)
	return zh_hant_intro_region_microstates_description(inputs)
});